"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validation = void 0;
/* --------------- UTILITIES : VALIDATION --------------- */

var validation = {
  general: {
    test: null,
    message: 'You must fill in this field'
  },
  //payment information validation with specific messaging
  paypalUserName: {
    test: /^(?!\s)(?=[\S\s]{2,150}$)[\S\s]*/,
    //REGEX CHANGED
    message: 'You need to enter a valid Paypal user name'
  },
  bankName: {
    test: /^(?!\s)(?=[\S\s]{2,150}$)[\S\s]*/,
    //REGEX CHANGED
    message: 'Please enter a valid bank name'
  },
  accountName: {
    test: /^(?!\s)(?=[\S\s]{2,150}$)[\S\s]*/,
    //REGEX CHANGED
    message: 'Please enter a valid account/company name'
  },
  routingNumber: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/,
    //REGEX CHANGED
    message: 'Please enter a valid routing number'
  },
  accountNumber: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/,
    //REGEX CHANGED
    message: 'Please enter a valid account number'
  },
  bankAddress: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/,
    //REGEX CHANGED
    message: 'You need to enter a valid address'
  },
  bankCity: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    //REGEX CHANGED
    message: 'Please enter a valid city'
  },
  bankState: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    //REGEX CHANGED
    message: 'Please enter a valid state'
  },
  bankZip: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,12}$/,
    //REGEX CHANGED
    message: 'Please enter a valid zip code'
  },
  bankCountry: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    //REGEX CHANGED
    message: 'Please enter a valid country'
  },
  swift: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,20}$/,
    //REGEX CHANGED
    message: 'Please enter a valid SWIFT'
  },
  iban: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/,
    ///^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,20}$/, //REGEX CHANGED
    message: 'Please enter a valid IBAN'
  },
  payTo: {
    test: /^(?!\s)[a-zA-Z ]{2,150}$/,
    //REGEX CHANGED
    message: 'Please enter a valid name'
  },
  paymentAddress: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/,
    //REGEX CHANGED
    message: 'You need to enter a valid address'
  },
  //AUTH VALIDATION
  newPassword: {
    test: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]<>?/|.:;_-])(?=.{8,150})/,
    message: 'Please complete the secure password recommendations'
  },
  confirmedPassword: {
    test: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]<>?/|.:;_-])(?=.{8,150})/,
    message: 'Please enter a valid password',
    comparemessage: 'Passwords don’t match.'
  },
  signinpassword: {
    test: /^(?=[\S\s]{8,150}$)[\S\s]*/,
    message: 'Please enter a valid password'
  },
  name: {
    test: /^(?!\s)[a-zA-Z ]{2,150}$/,
    //REGEX CHANGED
    message: 'Please enter a valid name'
  },
  reportName: {
    test: /^(?!\s)[A-Za-z0-9'\-\s]{2,150}$/,
    //REGEX CHANGED
    message: 'A report name is required.'
  },
  fname: {
    test: /^(?!\s)[a-zA-Z ]{2,150}$/,
    //REGEX CHANGED
    message: 'You must enter a valid first name',
    emptymessage: 'You can\'t leave your name empty!'
  },
  lname: {
    test: /^(?!\s)[a-zA-Z ]{2,150}$/,
    //REGEX CHANGED
    message: 'You must enter a valid last name',
    emptymessage: 'You can\'t leave your last name empty!'
  },
  email: {
    test: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'sample@sample.com'
  },
  password: {
    test: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,150})/,
    message: 'You must enter a valid password'
  },
  phone: {
    test: /^(?!\s)[0-9'\.\(\)\+\-\s\,]{2,20}$/,
    //REGEX CHANGED
    message: 'You must enter a valid phone number'
  },
  domain: {
    test: /^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[a-z]{2,})?[^\/-]+?$/m,
    // with http protocol: [-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)
    message: 'Format should be http://www.sample.com'
  },
  storyURL: {
    test: /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)+\.*[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
    message: 'Format should be http://www.sample.com'
  },
  address: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,150}$/,
    //REGEX CHANGED
    message: 'You need to enter a valid address'
  },
  state: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    //REGEX CHANGED
    message: 'Please enter a valid state'
  },
  city: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    //REGEX CHANGED
    message: 'Please enter a valid city'
  },
  country: {
    test: /^(?!\s)[A-Za-z'\.\-\s\,]{2,50}$/,
    //REGEX CHANGED
    message: 'Please enter a valid country'
  },
  zip: {
    test: /^(?!\s)[A-Za-z0-9'\.\-\s\,]{2,12}$/,
    //REGEX CHANGED
    message: 'Please enter a valid zip code'
  },
  embedname: {
    test: /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]{0,150}$/,
    message: 'Please enter a valid embed name'
  },
  //COMMENT UNIT VALIDATION
  integrationName: {
    test: /^(?!\s)[A-Za-z0-9'\-\s]{1,191}$/,
    message: 'Please enter a valid integration name'
  },
  activeUsersIndicatorTitle: {
    test: /^(?!\s)[A-Za-z0-9'\-\s]{0,64}$/,
    message: 'Please enter a valid title'
  },
  buttonLabelText: {
    test: /^(?!\s)[A-Za-z0-9'\-\s]{1,128}$/,
    message: 'Please enter valid button text'
  },
  loginFormUrl: {
    test: /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)+\.*[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
    message: 'Format should be http://www.sample.com'
  },
  communityTitle: {
    test: /^(?!\s)[A-Za-z0-9'\-\s]{0,100}$/,
    message: 'Please enter a valid title'
  },
  ratingUnitTitle: {
    test: /^(?!\s)[!@#$%^&*(){}[\]<>?/|.:;_A-Za-z0-9'\-\s]{1,40}$/,
    message: 'Please enter a valid title'
  },
  firstRatingTitle: {
    test: /^(?!\s)[!@#$%^&*(){}[\]<>?/|.:;_A-Za-z0-9'\-\s]{1,40}$/,
    message: 'Please enter a valid title'
  },
  ratingThankYouMessage: {
    test: /^(?!\s)[!@#$%^&*(){}[\]<>?/|.:;_A-Za-z0-9'\-\s]{1,40}$/,
    message: 'Please enter a valid message'
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.validation = validation;